import { UpdateFormulario } from '@services/Formulario/Index';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import SurveyCreatorComponent from '@components/Modals/Admin/SurveyCreatorModal/Index';

const EditFormularioModal = ({ visible, selectedRow, onUpdate, closeModal }) => {

  const handleUpdate = async (json) => {
    try {
      const title = "Atenção!";
      const message = "As alterações realizadas neste modelo de formulário não afetarão os formulários que já foram associados anteriormente. Somente novas associações refletirão essas mudanças. Deseja continuar?"
      const warning = await SweetAlert.warning(title, message);

      if (!warning) return;

      SweetAlert.loading();
      const payload = {
        json: JSON.stringify(json),
        flgStatus: selectedRow.flgStatus,
        idSolicitacaoProcessoItem: selectedRow.idSolicitacaoProcessoItem,
        idProcesso: selectedRow.idProcesso,
        flgModelo: true
      };
      const result = await UpdateFormulario(selectedRow.id, payload);
      onUpdate(result);

      SweetAlert.success('Atualização Concluída!', 'Os dados foram atualizados com sucesso.');

      closeModal();
    } catch (error) {

      const errorMessage = error.parsed?.message || 'Não foi possível atualizar o formulário.';
      
      SweetAlert.error('Erro ao atualizar', errorMessage);
      console.error("Erro ao salvar atualizações", errorMessage);
    }
  };

  if (!selectedRow) return null;

  return (
    <SurveyCreatorComponent
      open={visible}
      initialJson={selectedRow.json || {}}
      onSave={handleUpdate}
      onClose={closeModal}
    />
  );
};

export default EditFormularioModal;